import { useState, type FormEvent } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const NAV_ITEMS = [
  { label: '首页', to: '/' },
  { label: '电影', to: '/category/movie' },
  { label: '电视剧', to: '/category/tv' },
  { label: '综艺', to: '/category/variety' },
  { label: '关于', to: '/about' },
];

export default function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const [keyword, setKeyword] = useState('');
  const [menuOpen, setMenuOpen] = useState(false);

  const handleSearch = (event: FormEvent) => {
    event.preventDefault();
    const q = keyword.trim();
    if (!q) return;
    navigate(`/search?q=${encodeURIComponent(q)}`);
    setMenuOpen(false);
  };

  const isActive = (to: string) => {
    if (to === '/') return location.pathname === '/';
    return location.pathname.startsWith(to);
  };

  return (
    <header className="sticky top-0 z-50 w-full bg-background-50/95 backdrop-blur border-b border-background-200">
      <div className="w-full px-4 md:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">
          <Link to="/" className="flex items-center gap-2 shrink-0 cursor-pointer">
            <span className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-lg bg-primary-600 text-background-50">
              <i className="ri-play-circle-fill text-xl md:text-2xl"></i>
            </span>
            <span className="text-lg md:text-xl font-bold text-foreground-950 tracking-tight">
              神马<span className="text-accent-500">视频</span>
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            {NAV_ITEMS.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className={`px-4 py-2 rounded-md text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                  isActive(item.to)
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-700 hover:text-primary-700 hover:bg-background-200'
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>

          <div className="hidden md:flex items-center">
            <form onSubmit={handleSearch} className="relative">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
              <input
                type="text"
                value={keyword}
                onChange={(event) => setKeyword(event.target.value)}
                placeholder="搜索影视名称、标签"
                className="w-56 lg:w-64 h-10 pl-9 pr-3 rounded-md border border-background-300 bg-background-100 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-300"
              />
            </form>
          </div>

          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setMenuOpen((prev) => !prev)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-md border border-background-300 text-foreground-800 cursor-pointer"
          >
            <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden border-t border-background-200 bg-background-50 animate-fade-in">
          <div className="px-4 py-4 space-y-2">
            <form onSubmit={handleSearch} className="relative mb-2">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
              <input
                type="text"
                value={keyword}
                onChange={(event) => setKeyword(event.target.value)}
                placeholder="搜索影视名称、标签"
                className="w-full h-10 pl-9 pr-3 rounded-md border border-background-300 bg-background-100 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400"
              />
            </form>
            {NAV_ITEMS.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                onClick={() => setMenuOpen(false)}
                className={`block px-4 py-2.5 rounded-md text-sm font-medium cursor-pointer ${
                  isActive(item.to)
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-700 hover:bg-background-200'
                }`}
              >
                {item.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}